import styled, { css } from 'styled-components';
import { FatLabel } from '@designSystem/typings';
import { HeaderLarge } from '@designSystem/typings';
import { IconButton } from '@designSystem/buttons/styled';
import colors from '@designSystem/colors';
import Button from '@root/src/app/designSystem/buttons';

export const PersonStyle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;

  @media screen and (max-width: 992px) {
    flex-direction: column;
    align-items: flex-start;
  } ;
`;

const labelStyles = css`
  color: ${colors.white};
  padding: 8px 16px;
  margin-left: 32px;

  & svg path {
    fill: ${colors.white};
  }
`;

export const FatLabelStyled = styled(FatLabel)`
  ${labelStyles}
  background-color: #f0f1f2;
  color: #858a97;

  & svg path {
    fill: #858a97;
  }
`;

export const NegativeLabel = styled(FatLabel)`
  ${labelStyles}
  background-color: ${colors.green};
`;

export const PositiveLabel = styled(FatLabel)`
  ${labelStyles}
  background-color: ${colors.red};
`;

export const IndeterminateLabel = styled(FatLabel)`
  ${labelStyles}
  background-color: ${colors.black};
`;

export const PersonInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0.5rem 0 0.5rem 0;
`;

export const StyledHeaderLarge = styled(HeaderLarge)`
  margin: 0;
  @media screen and (max-width: 992px) {
    font-size: 24px;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  & > button {
    margin-left: 16px;
  }
`;

export const ThreeDotsIconButton = styled(IconButton)`
  margin-left: 16px;
  margin-top: 4px;

  & svg {
    & path {
      fill: ${colors.green};
    }
  }

  &:active {
    & svg {
      & path {
        fill: ${colors.green};
      }
    }
  }
`;

type activeI = {
  isOpened?: boolean;
};

export const GenerateCertificateDropdownButton = styled.button<activeI>`
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  cursor: pointer;
  background-color: ${colors.green};
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  margin-left: 3px;

  &:hover {
    opacity: 0.7;
  }
  & svg {
    transform: ${(props) => (props.isOpened ? 'rotate(180deg)' : 'rotate(0)')};
  }
`;

export const GreenDropLink = styled.a`
  height: 40px;
  padding: 8px 24px 8px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  border-radius: 8px;
  cursor: pointer;

  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 23px;
  text-align: center;

  color: ${colors.green};
  background-color: white;
  width: 221px;

  &:hover {
    color: ${colors.green};
    background-color: ${colors.lighterGrey};
  }

  & svg {
    margin: 0;
    width: 16px;
    height: 16px;
    margin-right: 15px;
    & path {
      stroke: ${colors.green};
    }
  }
`;

export const StyledButton = styled(Button)`
  background-color: white;
  width: 100% !important;
  display: flex;
  justify-content: flex-start;

  &:hover {
    background-color: #f9f9f9;
  }

  & svg {
    margin-right: 15px;
    & path {
      stroke: ${colors.black};
    }
  }
`;

export const GreenDropButton = styled(StyledButton)`
  color: ${colors.green};

  &:hover {
    color: ${colors.green};
  }

  & svg {
    & path {
      stroke: ${colors.green};
    }
  }
`;

export const BlackDropButton = styled(StyledButton)`
  color: ${colors.black};

  &:hover {
    background-color: #f9f9f9;
    color: ${colors.black};
  }
`;

export const RedDropButton = styled(StyledButton)`
  color: ${colors.red};

  &:hover {
    background-color: #f9f9f9;
    color: ${colors.red};
  }

  & svg {
    & path {
      stroke: ${colors.red};
    }
  }
`;
